/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EvmAddressInfo = {
    ADDR: string;
    ADDRT: EvmAddressInfo.ADDRT;
    NM: string;
    SB: string;
    BL: string;
    BLP: string;
    TRXCNT: string;
};

export namespace EvmAddressInfo {

    export enum ADDRT {
        EOA = 'EOA',
        CA = 'CA',
    }


}

